var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3337 3.33317H6.66699C4.82604 3.33317 3.33366 4.82555 3.33366 6.6665V13.3332C3.33366 15.1741 4.82604 16.6665 6.66699 16.6665H13.3337C15.1746 16.6665 16.667 15.1741 16.667 13.3332V6.6665C16.667 4.82555 15.1746 3.33317 13.3337 3.33317ZM6.66699 1.6665C3.90557 1.6665 1.66699 3.90508 1.66699 6.6665V13.3332C1.66699 16.0946 3.90557 18.3332 6.66699 18.3332H13.3337C16.0951 18.3332 18.3337 16.0946 18.3337 13.3332V6.6665C18.3337 3.90508 16.0951 1.6665 13.3337 1.6665H6.66699Z",
    fill: "#141416"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1663 6.66667C14.6266 6.66667 14.9997 6.29357 14.9997 5.83333C14.9997 5.3731 14.6266 5 14.1663 5C13.7061 5 13.333 5.3731 13.333 5.83333C13.333 6.29357 13.7061 6.66667 14.1663 6.66667Z",
    fill: "#141416"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1663 10.0002C14.1663 12.3013 12.3008 14.1668 9.99967 14.1668C7.69849 14.1668 5.83301 12.3013 5.83301 10.0002C5.83301 7.69898 7.69849 5.8335 9.99967 5.8335C12.3008 5.8335 14.1663 7.69898 14.1663 10.0002ZM12.4997 10.0002C12.4997 11.3809 11.3804 12.5002 9.99967 12.5002C8.61892 12.5002 7.49967 11.3809 7.49967 10.0002C7.49967 8.61941 8.61892 7.50016 9.99967 7.50016C11.3804 7.50016 12.4997 8.61941 12.4997 10.0002Z",
    fill: "#141416"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.d1e7e465f34dd46f64d197b09419bf80.svg";
export { ForwardRef as ReactComponent };